import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { CUSTOMER_PERSONA_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation ExtractBriefPersonas(
    $brief: BriefInput!
    $projectId: ID!
    $brandVoiceId: ID
    $promptImageId: ID
    $promptDocumentId: ID
    $freestyleToolAllInstructionsData: JSON
    $urlExtractions: [UrlExtractionInput!]
    $language: String
  ) {
    extractBriefPersonas(
      brief: $brief
      projectId: $projectId
      brandVoiceId: $brandVoiceId
      promptImageId: $promptImageId
      promptDocumentId: $promptDocumentId
      freestyleToolAllInstructionsData: $freestyleToolAllInstructionsData
      urlExtractions: $urlExtractions
      language: $language
    ) {
      edges {
        node {
          ...CustomerPersona
        }
      }
    }
  }
  ${CUSTOMER_PERSONA_FRAGMENT}
`;

export const extractBriefPersonas = async (
  {
    brief,
    projectId,
    brandVoiceId,
    promptImageId,
    promptDocumentId,
    freestyleToolAllInstructionsData,
    urlExtractions,
    language,
  },
  options = null
) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      brief,
      projectId,
      brandVoiceId,
      promptImageId,
      promptDocumentId,
      freestyleToolAllInstructionsData: freestyleToolAllInstructionsData
        ? JSON.stringify(freestyleToolAllInstructionsData)
        : null,
      urlExtractions,
      language,
    },
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp(result.data) || [];
};
